module.exports = __webpack_public_path__ + "transparencia_cases.jpg?7f65458f4b459606b30711b1f4ba6347";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cases/transparencia_cases.jpg
// module id = 93
// module chunks = 0